import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import TextInputWithAdornment from '@shared/components/core/field/TextInputWithAdornment';
import { BodyMedium } from '@shared/components/core/text/Typography';
import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import { Trans, useTranslation } from 'react-i18next';

export interface IClientSecretDialogProps {
    secret?: string;
    open: boolean;
    onClose: () => void;
}

export default function ClientSecretDialog({ secret, open, onClose }: IClientSecretDialogProps) {
    const { t } = useTranslation();
    const { showSuccess } = AlertsContainer.useContainer();

    const copySecret = () => {
        navigator.clipboard.writeText(secret ?? '').then(() => {
            showSuccess(t('common:profile.share.copied'));
        });
    };

    if (!secret) return null;
    return (
        <ContentDialog
            open={open}
            onClose={onClose}
            onConfirm={onClose}
            confirmButtonText={t('common:done')}
            title={t('common:organization.projects.secret.title')}>
            <BodyMedium>
                <Trans>{t('common:organization.projects.secret.description')}</Trans>
            </BodyMedium>

            <TextInputWithAdornment
                value={secret ?? ''}
                readOnly
                onClick={copySecret}
                inputLabel={t('common:organization.projects.secret.title')}
                actionLabel={t('common:organization.projects.secret.copy')}
            />
        </ContentDialog>
    );
}
